
  import { mapGetters } from 'vuex'
  export default {
    props: {
      mini: {
        type: Boolean,
        default: false
      }
    },
    data: () => ({
      dialog: false
    }),
    computed: {
      ...mapGetters({
        topDepositRanking: 'cms/topDepositRanking'
      })
    },
    mounted() {
      // Call this store action only when player/deposits
      if (this.$route.path !== '/' && !this.topDepositRanking?.component_code)
        this.$store.dispatch('cms/cmsComponentCode', {
          // platform: this.isMobileOnly() ? 2 : 1,
          platform: 1,
          component_code: 'TopDepositRanking'
        })
    }
  }
